import { Component, OnInit, ChangeDetectorRef, HostListener, Input } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { ServicerequestService,TicketsService,FacilityService } from 'src/app/services';
import {DashBoardServiceRequest, UserFacility, UserLocationFacility} from 'src/app/models'
import { ActivatedRoute,Router } from '@angular/router';
@Component({
  selector: 'bart-dash-service-request',
  templateUrl: './dash-service-request.component.html',
  styleUrls: ['./dash-service-request.component.scss']
})
export class DashServiceRequestComponent implements OnInit {
  @Input() userId:number;
  @Input() boxHeight: number;
  @Input() userName:number;
  //#region Variable Declaration
  public userFacilityIdList:string;
  maxRecords = 200;
  returnTotalCount = 0;
  returnAllRecords = 0;
  queryTimeout = 60;
  requestStatusID = 2;
  searchTerm:string=null


  public serviceRequesttList: DashBoardServiceRequest[];
  public dbserviceRequests: DashBoardServiceRequest[];
  public cols: any[];
  rows: number;
  public totalRecords:number=0;
  loading = false;
  showGlobalLoader:boolean=false;
  isPaginatorVisible:boolean=false;
  showSRDetails=false;
  servReqDetail:DashBoardServiceRequest;
  //#endregion
  constructor
  (
        private changeDetectorRef: ChangeDetectorRef, 
        private activatedRoute: ActivatedRoute,
        private sRequest: ServicerequestService,
        private _ticketService:TicketsService,
        private router: Router ,
        private facilityService:FacilityService
  ) {}
  ngOnInit() {
    this.rows = this.maxRecords;
    this.totalRecords=0;
    this.serviceRequesttList=[];
    this.loading = true;
   
    this.facilityService.getUserLocationFacilities(this.userName,(facilities:UserLocationFacility[])=>
    {
      if(facilities)
      {
        let userFacilityList:UserLocationFacility[]=facilities;
        this.userFacilityIdList=userFacilityList.map(x => x.FacilityMasterID).join(", ");
        this.getServiceRequestsNew();
      }
    });
  }

  public getServiceRequestsNew() {
    this.loading = true;
   let GETSERVICEREQUEST={    
    serviceRequestId:null,
		WorkTypeID:null,
		sqaCodeId:null,
		equipmentId:null,
		facilityMasterIdList:this.userFacilityIdList,
		RequestStatusID:2,
		returnTotalCount:null,
		returnAllRecords:1,
		maxRecords:50,
		orderBy:"dateServiceDue ASC, serviceRequestId ASC",
		searchTerm:this.searchTerm
    }
    this.serviceRequesttList=null
if (GETSERVICEREQUEST != null) {
      this.sRequest.getServiceRequest(JSON.stringify({GETSERVICEREQUEST}))
      .subscribe((resp: Array<any>) => {
          this.dbserviceRequests = resp;
          this.totalRecords = this.dbserviceRequests.length;
          this.serviceRequesttList=this.dbserviceRequests;//this.dbserviceRequests.slice(0, this.rows);
          this.loading = false;
          this.isPaginatorVisible=true;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        }, 
        (error) => 
        {
          console.log(error);
          this.dbserviceRequests = [];
          this.loading=false
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          // handle error here
        }
      );
    }
  }
  public loadDataOnScroll(event: LazyLoadEvent) {
    if(this.dbserviceRequests && this.totalRecords>this.rows)
    {
        this.loading = true;
        this.totalRecords=this.dbserviceRequests.length
        setTimeout(() => {
          this.serviceRequesttList = this.dbserviceRequests? this.dbserviceRequests.slice(event.first, (event.first + event.rows)) : [];
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
      }, 1000);
    }
  }
  public showDeatils(serviceRequestId:number)
  {
    this.servReqDetail=null;
    this.servReqDetail=this.dbserviceRequests.find(x=>x.ServiceRequestID==serviceRequestId)
    this.showSRDetails=true;
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }
  public getServiceRequestRowCSSClass(servReq:DashBoardServiceRequest,i:number)
  {
      let rowClass = null;
      if (servReq.pmSequenceId) {
          rowClass = 'srOddRowPM';
          if (i % 2 == 0) {
              rowClass = 'srEvenRowPM';
          }
      } else {
          rowClass = 'srOddRow';
          if (i % 2 == 0) {
              rowClass = 'srEvenRow';
          }
      }

      if (servReq.RequestDescription !=null && servReq.RequestDescription.indexOf("Custom") != -1) {
          rowClass = 'srCustomOddRow';
          if (i % 2 == 0) {
              rowClass = 'srCustomEvenRow';
          }
      }

      if (servReq.RequestSourceID == 3) {
          rowClass = 'srManualOddRow';
          if (i % 2 == 0) {
              rowClass = 'srManualEvenRow';
          }
      }
      return rowClass+" servReqRow"
  }
  public createTickt(requestId:number)
  {
     try
     {
      this.showGlobalLoader=true;
        let createTicketFromServiceRequestParam=
        {
          "CREATETICKETFROMSERVICEREQUEST":{
            ServiceRequestID:requestId,
            UserId:this.userId
          }
         }

       this._ticketService.createTicketFromServiceRequest(JSON.stringify(createTicketFromServiceRequestParam)).subscribe(data=>
        {
          this.showGlobalLoader=false;
          if(data!=null && data.length>0)
          {
            let ticketId=data[0].TicketID;
            this.router.navigate(['/tickets', ticketId]);
          }
        },
        (error)=>
        {
          this.showGlobalLoader=false;
           console.log(error);
        }
        )

     }
     catch(ex)
     {
      this.showGlobalLoader=false;
       console.log(ex);
     }
  }
  public clearSearch()
  {
    this.searchTerm="";
  }
}
  


